import _styled from '@emotion/styled/base';
import isPropValid from '@emotion/is-prop-valid';
import { shorthandSpacingCss } from '../primitives/Spacer/index.js';

const StyledFlex = _styled('div', {
  shouldForwardProp: prop => isPropValid(prop) && !['size', 'loading'].includes(prop),
  target: "e2m4m6s0"
})(shorthandSpacingCss, ";");

export { StyledFlex };
